class Select {
	constructor() {
		this.body = document.querySelector("body");
		this.selects = document.querySelectorAll(".select");
		if (this.selects.length) {
			this.buildSelects();
			this.selectCloseAction();
		}
	}

	buildSelects() {
		this.selects.forEach(select => {
			select.addEventListener("click", () => {
				setTimeout(() => {
					select.classList.toggle("active");
					this.body.classList.toggle("select-active");
				}, 0);
			});
		});
	}

	selectCloseAction() {
		this.body.addEventListener("click", (event) => {
			const target = event.composedPath().includes(document.querySelector(".select.active"));
			console.log("clic anywhere");
			if (this.body.classList.contains("select-active") && !target) {
				console.log("clic outside active select");
				const selectsActive = document.querySelectorAll(".select.active");
				selectsActive.forEach(select => {
					select.classList.remove("active");
					this.body.classList.remove("select-active");
				});
			}
		});
	}
}